var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpenStateIssue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22037",
    "data-name": "Group 22037",
    transform: "translate(-106 -344)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22471",
    "data-name": "Rectangle 22471",
    width: 12,
    height: 12,
    rx: 6,
    transform: "translate(106 344)",
    fill: "#e8b202"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-refresh-cw",
    "data-name": "Icon feather-refresh-cw",
    transform: "translate(107 342.634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38875",
    "data-name": "Path 38875",
    d: "M27.409,6V7.909H25.5",
    transform: "translate(-18.909 -1.179)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38876",
    "data-name": "Path 38876",
    d: "M1.5,22.909V21H3.409",
    transform: "translate(0 -12.997)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38877",
    "data-name": "Path 38877",
    d: "M2.3,6.412A2.864,2.864,0,0,1,7.024,5.343L8.5,6.73M1.5,8,2.976,9.39A2.864,2.864,0,0,0,7.7,8.321",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.8
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenStateIssue);
export default __webpack_public_path__ + "static/media/open_state_issue.bbe4c7eec6c577c57024c3fad2b3b810.svg";
export { ForwardRef as ReactComponent };